﻿import { AnalyticsApi } from './AnalyticsApi.ts'
import { createMockDelay, MOCK_DELAYS } from '../rundot-game-api/systems/core.js'

export class MockAnalyticsApi implements AnalyticsApi {
  async recordCustomEvent(
    eventName: string,
    payload: Record<string, any>,
  ): Promise<void> {
    await createMockDelay(MOCK_DELAYS.short)
  }

  async trackFunnelStep(stepNumber: number, stepName: string, funnelName?: string, funnelOrder?: number): Promise<void> {
    await createMockDelay(MOCK_DELAYS.short)
  }
}
